import script from "./PalLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./PalLabel.vue?vue&type=script&setup=true&lang=js"

import "./PalLabel.vue?vue&type=style&index=0&id=833e1abc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-833e1abc"]])

export default __exports__